import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'bg-bg-items-white flex flex-col py-3 pr-3 pl-4',
    header: 'flex w-full items-center justify-between max-lg:cursor-pointer',
    label: 'flex items-center gap-2',
    chevron: 'block rotate-90 transition-transform',
    searchContainer: 'pb-1',
    options: 'mt-3 flex flex-col gap-7 pb-5',
    collapse: '',
    checkbox: 'bg-transparent'
  },
  variants: {
    collapse: {
      false: {
        chevron: '-rotate-90',
        collapse: '!max-h-max'
      }
    }
  }
});
